export default __webpack_public_path__ + "static/media/seven.7bb74af8.jpg";